/*
 *
 * LeadsPage actions
 *
 */

import {
    DOWNLOAD_LEADS_REQUEST,
    FETCH_LEADS_REQUEST,
    FETCH_LEADS_SUCCESS,
    FETCH_LEADS_FAIL,
    DOWNLOAD_LEADS_SUCCESS,
    DOWNLOAD_LEADS_FAIL,
  } from './constants';
  
  export const downLoadLeadRequest = (params = null) => ({
    type: DOWNLOAD_LEADS_REQUEST,
    params
  });

  export const downLoadLeadSuccess = () => ({
    type: DOWNLOAD_LEADS_SUCCESS,
  });

  export const downLoadLeadFail = ({ errors }) => ({
    type: DOWNLOAD_LEADS_FAIL,
    errors
  });

  export const fetchLeadsRequest = (params = null) => ({
    type: FETCH_LEADS_REQUEST,
    params
  });

  export const fetchLeadSuccess = (payload) => ({
    type: FETCH_LEADS_SUCCESS,
    ...payload
  });

  export const fetchLeadFail = ({ errors }) => ({
    type: FETCH_LEADS_FAIL,
    errors
  });
    


// WEBPACK FOOTER //
// ./src/containers/LeadsPage/actions.js